<section class="_topbar" [class.sidebar-open]="sidebarOpen()">
    <section class="topbar-wrapper">
        <epx-env-indicator></epx-env-indicator>
        <app-top-bar-actions></app-top-bar-actions>
    </section>
</section>
